import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';
import { MobileNavigationService } from './mobile-navigation.service';
import { RegistrationService } from './registration.service';

@Injectable({ providedIn: 'root' })
export class AuthDialogService {
  private readonly document = inject(DOCUMENT);
  private readonly mobileNavigation = inject(MobileNavigationService);
  private readonly registrationService = inject(RegistrationService);
  private readonly loginOpenSignal = signal(false);
  private focusOrigin: HTMLElement | null = null;

  readonly loginOpen = this.loginOpenSignal.asReadonly();

  openLogin(): void {
    this.mobileNavigation.close();
    const activeElement = this.document.activeElement;
    this.focusOrigin = activeElement instanceof HTMLElement ? activeElement : null;
    this.loginOpenSignal.set(true);
  }

  closeLogin(): void {
    if (!this.loginOpenSignal()) {
      return;
    }

    this.loginOpenSignal.set(false);
    const focusOrigin = this.focusOrigin;
    this.focusOrigin = null;
    this.document.defaultView?.requestAnimationFrame(() => focusOrigin?.focus({ preventScroll: true }));
  }

  openSignup(): void {
    this.mobileNavigation.close();
    this.registrationService.openRegistration();
  }
}
